<template>
  <FundModal
    v-if="showFundModal"
    title="Fund Wallet"
    :subTitle="fundSubTitle"
    :form="fundForm"
    @close="closeFundModal"
    :showBackButton="fundForm !== 'fundOptionsForm'"
    @goBack="goBackFund"
    @mounted="refreshFund"
  >
    <template v-slot:content>
      <FundOptionsForm
        v-if="fundForm === 'fundOptionsForm'"
        class="tw-px-4 lg:tw-px-6"
        :isAllowed="isAllowed"
        @options="switchFundForm"
        :currency="currency"
      />

      <DedicatedVirtualAccountForm
        v-if="fundForm === 'DedicatedVirtualAccountForm'"
        class="tw-px-4 md:tw-px-10"
      />

      <FundAmountForm
        v-if="fundForm === 'fundAmountForm'"
        :fundOptions="fundOptions"
        class="tw-px-4 md:tw-px-10"
        @storeData="switchFundForm"
      />

      <CardOptionsForm
        v-if="fundForm === 'CardOptions'"
        class="tw-px-4 md:tw-px-10"
        @storeData="switchFundForm"
      />

      <FundConfirmationForm
        v-if="fundForm === 'fundConfirmationForm'"
        class="tw-px-4 lg:tw-px-10"
        :fees="withdrawFees"
        @storeData="switchFundForm"
        :fundOptions="fundOptions"
        @close="closeFundModal"
      />

      <WalletList
        @wallet-select="fundFromWallet"
        @close="$emit('close-modal', 'Fund Wallet')"
        v-if="fundForm === 'walletList'"
      />

      <SelectDebitCardForm
        v-if="fundForm === 'SelectDebitCardForm'"
        :fundOptions="fundOptions"
        @storeData="switchWithdrawForm"
      />

      <SelectFinTechWallet
        @close="closeModal"
        v-if="fundForm === 'SelectFinTechWallet'"
      />

      <SelectCurrencyForm
					:selectedCurrency="currency"
					v-if="fundForm === 'SelectCurrencyForm'"
					:fundOptions="fundOptions"
					@storeData="switchWithdrawForm"
				/>
    </template>
  </FundModal>
</template>

<script>
import { computed, provide, watchEffect } from "vue";
import FundModal from "@/components/general/sidemodal/SideModal.vue";
import CardOptionsForm from "@/components/wallet/fund/CardOptionsForm.vue";
import DedicatedVirtualAccountForm from "@/components/wallet/fund/DedicatedVirtualAccountForm.vue";
import FundAmountForm from "@/components/wallet/fund/FundAmountForm.vue";
import FundConfirmationForm from "@/components/wallet/fund/FundConfirmationForm.vue";
import FundOptionsForm from "@/components/wallet/fund/FundOptionsForm.vue";
import WalletList from "@/components/wallet/withdraw/WalletList.vue";
import SelectCurrencyForm from "@/components/wallet/fund/SelectCurrencyForm.vue";
import SelectDebitCardForm from "@/components/wallet/fund/SelectDebitCardForm.vue";
import SelectFinTechWallet from "@/components/wallet/fund/SelectFinTechWallet.vue";
import { useFundModal } from "@/composables/useFundModal";

export default {
  name: "FundWalletModal",

  components: {
    FundModal,
    CardOptionsForm,
    DedicatedVirtualAccountForm,
    FundAmountForm,
    FundConfirmationForm,
    FundOptionsForm,
    WalletList,
    SelectDebitCardForm,
    SelectCurrencyForm,
    SelectFinTechWallet
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    withdrawFees: {
      type: Number,
      default: 0,
    },
  },

  emits: ["close", "fund-success"],

  setup(props, { emit }) {
    const {
      showFundModal,
      fundSubTitle,
      fundForm,
      swapCurrency,
      fundPayload,
      fundOptions,
      isAllowed,
      currency,
      entityCard,
      fundMethod,
      virtualAccount,
      getProvider,
      openFundModal,
      closeFundModal: composableCloseFundModal,
      switchFundForm,
      goBackFund,
      fundFromWallet,
      refreshFund,
    } = useFundModal();

    watchEffect(() => {
      showFundModal.value = props.visible;
    });

    const closeFundModal = () => {
      composableCloseFundModal();
      emit("close");
    };

    provide(
      "provider",
      computed(() => getProvider.value)
    );
    provide(
      "swapCurrency",
      computed(() => swapCurrency.value)
    );

    return {
      showFundModal,
      fundSubTitle,
      fundForm,
      fundOptions,
      isAllowed,
      switchFundForm,
      goBackFund,
      fundFromWallet,
      refreshFund,
      closeFundModal,
      currency,
    };
  },
};
</script>